import React, { useState } from "react";
import { Dropdown } from "../Dropdown";
const PageDropdown = ({ pageOptions, OnPageChanged, disabled = false, }) => {
    const [selectedValue, setSelectedValue] = useState("");
    const handleChange = (value) => {
        setSelectedValue(value !== null && value !== void 0 ? value : '');
        OnPageChanged(value !== null && value !== void 0 ? value : '');
    };
    return (React.createElement(Dropdown, { items: pageOptions, displayName: "label", displayValue: "value", label: "Select a page", value: selectedValue, onChange: handleChange, disabled: disabled }));
};
export default PageDropdown;
